import { modal as actions } from '../actions'


export const initialState = {
	open: false,
	title: null,
	body: null,
	color: 'blue-dark',
	choices: []
}


export const setModal = data => dispatch => {
	dispatch({
		type: actions.SET_MODAL,
		data
	})
}